import React from "react";
import { useTranslation } from "react-i18next";

//irina
function Experience() {
  const { t } = useTranslation("homepage");

  return (
    <section className="tc-experience-style1 section-padding-x" style={{ 
      backgroundColor: '#ffffff', 
      padding: '100px 0',
      marginTop: '60px'
    }}>
      <div className="container" style={{
        paddingLeft: window.innerWidth < 992 ? '24px' : '60px',
        paddingRight: window.innerWidth < 992 ? '24px' : '60px'
      }}>
        <div className="row align-items-center">
          {/* Left Side - Number */}
          <div className="col-lg-2 col-md-12 mb-4 mb-lg-0">
            <div className="experience-number-section" style={{
              textAlign: 'center',
              padding: '0 20px'
            }}>
              <div className="experience-number" style={{
                fontSize: window.innerWidth < 768 ? '4rem' : '6rem',
                fontWeight: '700',
                color: '#333',
                fontFamily: 'Montserrat, sans-serif',
                lineHeight: '1',
                marginBottom: '10px'
              }}>
                20+
              </div>
              <div className="experience-label" style={{
                fontSize: window.innerWidth < 768 ? '0.85rem' : '1rem',
                color: '#666',
                fontWeight: '400',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                lineHeight: '1.2'
              }}>
                {t("experience.yearsLabel")}
              </div>
            </div>
          </div>
          
          {/* Center - Image */}
          <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <div className="experience-image" style={{
              position: 'relative',
              height: window.innerWidth < 768 ? '220px' : '360px',
              borderRadius: '15px',
              overflow: 'hidden',
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
            }}>
              <img
                src="/home1/assets/img/slider/1.jpg"
                alt="OneArt Construction"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
              <div className="image-overlay" style={{
                position: 'absolute',
                bottom: '0',
                left: '0',
                right: '0',
                background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                padding: window.innerWidth < 768 ? '20px' : '40px',
                color: 'white'
              }}>
                <h4 style={{
                  fontSize: window.innerWidth < 768 ? '1.2rem' : '1.5rem',
                  fontWeight: '600',
                  marginBottom: '10px',
                  fontFamily: 'Montserrat, sans-serif'
                }}>OneArt Construction</h4>
                <p style={{
                  fontSize: window.innerWidth < 768 ? '0.9rem' : '1rem',
                  opacity: '0.9',
                  lineHeight: '1.5'
                }}>{t("overview.imageSubtitle")}</p>
              </div>
            </div>
          </div>
          
          {/* Right Side - Text */}
          <div className="col-lg-4 col-md-12">
            <div className="experience-content" style={{
              padding: '0 20px'
            }}>
              <h3 style={{
                fontSize: window.innerWidth < 768 ? '1.8rem' : '2.2rem',
                fontWeight: '600',
                color: '#333',
                marginBottom: '30px',
                fontFamily: 'Montserrat, sans-serif',
                lineHeight: '1.2'
              }}>
                {t("experience.mainTitle")}
              </h3>
              <div className="experience-description" style={{
                fontSize: window.innerWidth < 768 ? '0.9rem' : '1rem',
                color: '#666',
                lineHeight: '1.8',
                marginBottom: '40px'
              }}>
                {t("experience.description")
                  .split(/(oneart)/i)
                  .map((part, index) =>
                    part.toLowerCase() === "oneart" ? (
                      <span
                        key={index}
                        style={{
                          fontFamily: "Montserrat, sans-serif",
                          textTransform: "uppercase",
                          color: "rgb(73, 69, 56)",
                          fontWeight: "600"
                        }}
                      >
                        {part}
                      </span>
                    ) : (
                      part
                    )
                  )}
              </div>
              
              <div className="experience-buttons" style={{ 
                display: 'flex', 
                gap: '14px', 
                flexWrap: 'wrap',
                justifyContent: window.innerWidth < 768 ? 'center' : 'flex-start'
              }}>
                <a
                  href="/innerpages/portfolio"
                  className="btn-experience"
                  style={{
                    backgroundColor: 'transparent',
                    color: 'rgb(73, 69, 56)',
                    padding: window.innerWidth < 768 ? '8px 18px' : '10px 22px',
                    borderRadius: '4px',
                    textDecoration: 'none',
                    fontSize: window.innerWidth < 768 ? '0.78rem' : '0.85rem',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.8px',
                    transition: 'all 0.3s ease',
                    display: 'inline-block',
                    border: '1.5px solid rgb(73, 69, 56)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(191,129,80,0.08)';
                    e.target.style.color = 'rgb(73, 69, 56)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = 'rgb(73, 69, 56)';
                  }}
                >
                  {t("experience.buttons.projects")}
                </a>
                <a
                  href="/innerpages/contact"
                  className="btn-experience"
                  style={{
                    backgroundColor: 'transparent',
                    color: 'rgb(73, 69, 56)',
                    padding: window.innerWidth < 768 ? '8px 18px' : '10px 22px',
                    borderRadius: '4px',
                    textDecoration: 'none',
                    fontSize: window.innerWidth < 768 ? '0.78rem' : '0.85rem',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.8px',
                    transition: 'all 0.3s ease',
                    display: 'inline-block',
                    border: '1.5px solid rgb(73, 69, 56)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(191,129,80,0.08)';
                    e.target.style.color = 'rgb(73, 69, 56)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = 'rgb(73, 69, 56)';
                  }}
                >
                  {t("experience.buttons.contact")}
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Statistics Row */}
        
      </div>
    </section>
  );
}

export default Experience;
